import { map } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import { blockBackgroundColors } from '@constants';
import { cmsImagePropTypes } from '../../prop-types';
import { Container, Flex } from '../grid';
import { P } from '../typography/new';
import { Image } from '../image';
import { imageTransform } from '../../content/transforms';
import { matrixBlockQuery, valuesItemsQuery } from '../../content/query-snippets';
import { BlockHeader } from '../block-header';

const ValuesBlock = ({ heading, viBody, items, viBackground }) => {
  const currentBackgroundColor = blockBackgroundColors?.[viBackground];
  return (
    <Flex
      backgroundColor={currentBackgroundColor}
      py={currentBackgroundColor !== 'transparent' && currentBackgroundColor && { xs: '64px', lg: '120px' }}
      my={(currentBackgroundColor === 'transparent' || !currentBackgroundColor) && { xs: '64px', lg: '120px' }}
      width="100%"
      justifyContent="center"
    >
      <Container variant="featuredContent" width="100%">
        <BlockHeader heading={heading} body={viBody} mb={{ xs: '36px', lg: '56px' }} />
        <Flex justifyContent="center" flexDirection={{ xs: 'column', md: 'row' }} gap={{ xs: '40px', md: '24px' }}>
          {map(items, ({ image, heading: itemHeading, description }) => {
            const transformedImage = imageTransform(image);
            return (
              <Flex width="100%" maxWidth={{ md: '364px' }} textAlign="center" flexDirection="column" display="flex">
                <Flex display="flex" alignItems="center" width="100%" style={{ aspectRatio: '1 / 1' }}>
                  <Image
                    alt={transformedImage?.alt}
                    focalPoint={transformedImage?.focalPoint}
                    src={transformedImage?.url}
                    srcSet={transformedImage?.srcset}
                    borderRadius="24px"
                    objectFit="cover"
                    height="100%"
                    width="100%"
                  />
                </Flex>
                <Flex width="100%" mt={{ xs: '20px', lg: '24px' }} flexDirection="column" justifyContent="center">
                  <P mb="6px" variant="extra-large-semi-bold">
                    {itemHeading}
                  </P>
                  <P variant="medium">{description}</P>
                </Flex>
              </Flex>
            );
          })}
        </Flex>
      </Container>
    </Flex>
  );
};

ValuesBlock.propTypes = {
  heading: PropTypes.string,
  viBody: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      heading: PropTypes.string,
      description: PropTypes.string,
      image: PropTypes.oneOfType([cmsImagePropTypes, PropTypes.arrayOf(cmsImagePropTypes)]),
    })
  ),
  viBackground: PropTypes.oneOf(['offWhite', 'transparent']),
};

ValuesBlock.defaultProps = {
  heading: '',
  viBody: '',
  items: [{}],
  viBackground: 'transparent',
};

ValuesBlock.query = `
  ... on contentMatrix_valuesBlock_BlockType {
    ${matrixBlockQuery}
    heading
    viBody
    viBackground
    ${valuesItemsQuery}
  }
`;

export { ValuesBlock };
